import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const getIframe = (id, height) => {
  const iframeContainer = document.querySelector(`#${id}`)

  iframeContainer.addEventListener('load', () => {
    try {
      iframeContainer.contentWindow.postMessage({ filterState: JSON.parse(localStorage.getItem('filterState')), height }, 'https://analytics.premierleague.com/')
    } catch (error) {
      console.log('Error when sending viewport height:', error)
    }
  })
}

const getViewportSize = (setState) => {
  const handleResize = () => {
    setState(window.innerHeight)
  }

  window.addEventListener('resize', handleResize)
  handleResize()
  return () => window.removeEventListener('resize', handleResize)
}

const Iframe = ({ url, style, constituencyDownloadPDF }) => {
  const [screenHeight, setScreenHeight] = useState()
  const [iframeData, setIframeData] = useState({ data: '', origin: '' })

  const handleMessage = (event) => {
    const { data, origin } = event
    if (origin.includes('https://analytics.premierleague.com') && data) {
      if (typeof data === 'number') {
        setIframeData({ data, origin })
      } else {
        localStorage.setItem('filterState', data.selections)
      }
    }
  }
  useEffect(() => {
    getViewportSize(setScreenHeight)
    getIframe('iframe_container', screenHeight)
    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [screenHeight])

  return (
    <iframe
      id='iframe_container'
      src={url}
      style={{ height: `${iframeData.data}px` }}
    />
  )
}

Iframe.propTypes = {
  constituencyDownloadPDF: PropTypes.func,
  style: PropTypes.string,
  url: PropTypes.string
}

export default (Iframe)
